
import { defineComponent, PropType } from 'vue'

const colorVariants = ['vanilla', 'aqua', 'juniper', 'amber', 'cherry'] as const

export default defineComponent({
  name: 'UITag',
  props: {
    label: {
      type: String,
      required: true
    },
    color: {
      type: String as PropType<(typeof colorVariants)[number]>,
      default: 'vanilla',
      validator: (value: (typeof colorVariants)[number]) => colorVariants.includes(value)
    },
    icon: {
      type: String,
      default: ''
    }
  },
  computed: {
    labelColor(): string {
      const colorMap: Record<(typeof colorVariants)[number], string> = {
        vanilla: 'bg-vanilla-400/20 text-vanilla-400',
        aqua: 'bg-aqua-400/20 text-aqua-400',
        juniper: 'bg-juniper/20 text-juniper-400',
        amber: 'bg-amber/20 text-amber',
        cherry: 'bg-cherry/20 text-cherry'
      }
      return colorMap[this.color]
    }
  }
})
